module.exports = __webpack_public_path__ + "img/leumicard.dea37919.jpg";